import { render } from "./ClinicalFormulationDrugExemptions.vue?vue&type=template&id=44b07bc3"
import script from "./ClinicalFormulationDrugExemptions.vue?vue&type=script&lang=js"
export * from "./ClinicalFormulationDrugExemptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/ClinicalFormulationDrugExemptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44b07bc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44b07bc3', __exports__)) {
    api.reload('44b07bc3', __exports__)
  }
  
  module.hot.accept("./ClinicalFormulationDrugExemptions.vue?vue&type=template&id=44b07bc3", () => {
    api.rerender('44b07bc3', render)
  })

}


export default __exports__